export default __webpack_public_path__ + "static/media/basic-plan.2f14eee3.webp";